import { render, staticRenderFns } from "./24VDCPSU.vue?vue&type=template&id=48c9f9d8&scoped=true&"
import script from "./24VDCPSU.vue?vue&type=script&lang=js&"
export * from "./24VDCPSU.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c9f9d8",
  null
  
)

export default component.exports